var React = require('react');

function PersonContactIcon (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1552_2912)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.8755 12.0005C14.3612 12.0005 16.3757 9.9856 16.3757 7.50026C16.3757 5.01492 14.3612 3 11.8755 3C9.38977 3 7.3752 5.01492 7.3752 7.50026C7.3752 9.9856 9.38977 12.0005 11.8755 12.0005ZM13.658 13.6881H10.0929C6.72864 13.6881 4 16.4164 4 19.7811C4 20.454 4.54566 21 5.21859 21H18.533C19.206 21.0011 19.7509 20.4561 19.7509 19.7811C19.7509 16.4164 17.0226 13.6881 13.658 13.6881Z","fill":"#E60005"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1552_2912"},React.createElement("rect",{"width":"24","height":"24","fill":"white"})))]);
}

PersonContactIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = PersonContactIcon;

PersonContactIcon.default = PersonContactIcon;
